import PropTypes from 'prop-types'
import React from 'react'
import { findDOMNode } from 'react-dom'

export class ClickOutside extends React.Component {
  static propTypes = {
    ignore: PropTypes.array,
    onClickOutside: PropTypes.func
  }

  constructor (...args) {
    super(...args)

    this.handleClickOutside = this.handleClickOutside.bind(this)
  }

  componentDidMount () {
    window.addEventListener('click', this.handleClickOutside, true)
  }

  componentWillUnmount () {
    window.removeEventListener('click', this.handleClickOutside, true)
  }
  
  handleClickOutside (event) {
    const node = findDOMNode(this)

    if (node.contains(event.target)) return

    this.props.onClickOutside && this.props.onClickOutside(event)
  }

  render () {
    return React.Children.only(this.props.children)
  }
}

export default ClickOutside
